import type { SVGProps } from "react";
import * as React from "react";

const SvgArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 13a1 1 0 1 0 0-2zM5 12l-.707-.707a1 1 0 0 0 0 1.414zm6.293 7.707a1 1 0 0 0 1.414-1.414zm1.414-14a1 1 0 0 0-1.414-1.414zM19 11H5v2h14zm-6.293 7.293-7-7-1.414 1.414 7 7zm-7-5.586 7-7-1.414-1.414-7 7z"
    />
  </svg>
);
export default SvgArrowLeft;
